import { IPatternWithNoPatternBusinessLogic } from '@vfde-brix/ws10/core';
import {
    createHeadline,
    Headline,
    IHeadlineProperties,
} from '@vfde-brix/ws10/headline';

/**
 * Mount headline
 */
export default function mountHeadline (
    id: string,
    properties: IHeadlineProperties | IPatternWithNoPatternBusinessLogic,
    dom = document,
): Headline | null {
    const container = dom.getElementById(id);

    return container && createHeadline(container, properties);
}
